<template>
    <nav class="menu" :class="{ 'is-sticky': isSticky }">
        <div class="menu-background">
            <button class="toggle-menu" v-if="isMobile" @click="toggleMenu">
                <span id="hamburger-btn" v-if="!isMenuOpen">&#9776;</span>
                <span id="close-btn" v-else>&times;</span>
            </button>
            <ul class="menu-list" :class="{ active: isMenuOpen }">
                <li class="logo-item">
                    <a href="#" @click="toggleMenu"><img :src="headerText.crLogoWhite" alt="Logo" class="logo" /></a>
                </li>
                <li v-for="item in filteredMenuItems" :key="item.id">
                    <a :href="item.link" @click="setActive(item.id)" :class="{ active: item.id === itemActive }">
                        {{ item.label }}
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name: "TheMenu",
    props: {
        headerText: Object,
        activeBlocks: Object,
    },
    data() {
        return {
            menuItems: [
                { id: 1, label: "PŘEDNÁŠEJÍCÍ", link: "#speakers", block: "speakers" },
                { id: 2, label: "PROGRAM", link: "#program", block: "program" },
                { id: 3, label: "CTF", link: "#ctf", block: "ctf" },
                { id: 4, label: "GALERIE", link: "#photogallery", block: "gallery" },
                { id: 5, label: "FEEDBACK", link: "#feedback", block: "feedback" },
                { id: 6, label: "PARTNEŘI", link: "#partner", block: "partners" },
                { id: 7, label: "KONTAKT", link: "#contact", block: "contacts" },
                { id: 8, label: "REGISTRACE", link: "#register", block: "register" },
                { id: 9, label: "FAQ", link: "#faq", block: "faq" },
                {
                    id: 10,
                    label: "PRO ÚČASTNÍKY",
                    link: "https://portal.cyber-rangers.com/",
                    block: "forParticipants",
                },
            ],
            isSticky: false,
            originalOffsetTop: null,
            isMenuOpen: false,
            isMobile: false,
            itemActive: null,
        };
    },
    computed: {
        filteredMenuItems() {
            if (!this.activeBlocks) return this.menuItems;
            return this.menuItems.filter((item) => this.activeBlocks[item.block]);
        },
    },
    mounted() {
        this.originalOffsetTop = this.$el.offsetTop || 0;
        window.addEventListener("scroll", this.handleScroll);
        this.checkIfMobile();
        window.addEventListener("resize", this.checkIfMobile);
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.checkIfMobile);
    },
    methods: {
        handleScroll() {
            if (window.pageYOffset > this.originalOffsetTop) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth < 1024;
            if (!this.isMobile) {
                this.isMenuOpen = false;
            }
        },
        setActive(itemId) {
            this.itemActive = itemId;
            this.isMenuOpen = false;
        },
    },
};
</script>

<style scoped>
/* Ukotvení (Sticky) */
.menu {
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1000;
}

.menu-background {
    width: 100%;
    min-height: 90px;
    background-color: var(--bg-panel);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--glass-border);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
}

/* Seznam odkazů */
.menu-list {
    list-style: none;
    margin: 0;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1400px;
    flex-wrap: wrap;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-list li {
    margin: 0 15px;
}

/* Specifické odsazení pro logo, ať není nalepené na text */
.logo-item {
    margin-right: auto !important;
}

.logo {
    max-width: 120px;
    display: block;
}

/* Odkazy */
.menu-list a {
    color: var(--text-secondary);
    text-decoration: none;
    font-family: var(--font-main);
    font-size: 12px;
    letter-spacing: 0.2em;
    font-weight: 700;
    padding: 10px 0;
    position: relative;
    transition: all 0.3s ease;
}

.menu-list a:hover,
.menu-list a.active {
    color: var(--accent-primary);
    text-shadow: 0 0 12px rgba(255, 152, 0, 0.6);
}

/* Tlačítko pro mobily */
.toggle-menu {
    background: none;
    border: none;
    padding: 20px;
    cursor: pointer;
    display: none;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1002;
    color: var(--accent-primary);
    text-shadow: 0 0 10px rgba(255, 152, 0, 0.5);
}

#hamburger-btn {
    font-size: 30px;
}

#close-btn {
    font-size: 40px;
    line-height: 0.5;
}

/* Mobil */
@media only screen and (max-width: 1024px) {
    .menu-background {
        justify-content: flex-start;
        padding-left: 20px;
    }

    .toggle-menu {
        display: block;
        top: 20px !important;
        transform: none !important;
        right: 10px;
        z-index: 1100;
        position: fixed;
    }

    #close-btn {
        font-size: 50px;
        line-height: 0.6;
        display: block;
        color: var(--accent-primary);
    }

    .logo-item {
        margin: 0 !important;
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 1002;
    }

    .menu-list {
        display: flex;
        position: fixed;
        top: 0;
        right: 0;
        width: 80%;
        max-width: 400px;
        height: 100vh;
        background: var(--bg-panel);
        backdrop-filter: blur(25px);
        -webkit-backdrop-filter: blur(25px);
        border-left: 1px solid var(--glass-border);
        box-shadow: -10px 0 30px rgba(0, 0, 0, 0.5);
        z-index: 1000;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 80px;
        transform: translateX(100%);
        visibility: hidden;
        pointer-events: none;
    }

    .menu-list.active {
        transform: translateX(0);
        visibility: visible;
        pointer-events: auto;
    }

    .menu-list li {
        margin: 12px 0 !important;
    }

    .menu-list a {
        font-size: 16px;
        letter-spacing: 0.3em;
    }
}
</style>
